// extracted by mini-css-extract-plugin
export var icon = "_q8-0";